import { HTTPClient } from "./Client";

const NotificacaoApi = {
    async MarcarNotificacaoComoLidoAsync(notificacaoId)
    {
        await HTTPClient.put(`/Notificacao/MarcarNotificacaoComoLido/${notificacaoId}`);

    },
    
    async ListarNotificacoesPorUsuarioIdAsync()
    {
        const response = await HTTPClient.get(`/Notificacao/ListarNotificacoesDoUsuario`);

        return response.data;
    },

    async QuantidadeNotificacoesUsuarioAsync()
    {
        const response = await HTTPClient.get(`/Notificacao/QuantidadeNotificacoesUsuario`);

        return response.data;
    },
}

export default NotificacaoApi;